import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
am4core.useTheme(am4themes_animated);
am4core.addLicense("ch-custom-attribution");
var colors = [am4core.color("#623e15"), am4core.color("#8E6537"), am4core.color("#A47948"), am4core.color("#B48854"), am4core.color("#B97527"), am4core.color("#CA9C65"), am4core.color("#D99648"), am4core.color("#e4b379")];
export function showPieChartIndicators(datas, container) {
  var piechart = am4core.create(container, am4charts.PieChart);
  piechart.colors.list = colors;
  piechart.data = datas;
  // Add and configure Series
  var pieSeries = piechart.series.push(new am4charts.PieSeries());
  pieSeries.dataFields.value = "value";
  pieSeries.dataFields.category = "text";
  pieSeries.labels.template.disabled = true;
  pieSeries.ticks.template.disabled = true;
  pieSeries.colors.list = colors;
}
export function showLineChartUserTypes(datas, container) {
  var linechart = am4core.create(container, am4charts.XYChart);
  linechart.colors.list = colors;
  linechart.data = datas;
  // Create axes
  var dateAxis = linechart.xAxes.push(new am4charts.DateAxis());
  dateAxis.renderer.minGridDistance = 50;
  dateAxis.renderer.grid.template.location = 0.5;

  // Create value axis
  var valueAxis = linechart.yAxes.push(new am4charts.ValueAxis());
  var series1 = linechart.series.push(new am4charts.LineSeries());
  series1.dataFields.valueY = "nb_pro";
  series1.dataFields.dateX = "date";
  series1.name = "Professionals ";
  series1.tooltipText = "{name}: [bold]{valueY} orders[/]";
  series1.strokeWidth = 1;
  series1.tensionX = 0.8;
  series1.bullets.push(new am4charts.CircleBullet());
  series1.connect = true;
  var series2 = linechart.series.push(new am4charts.LineSeries());
  series2.dataFields.valueY = "nb_ind";
  series2.dataFields.dateX = "date";
  series2.yAxis = valueAxis;
  series2.name = "Individuals";
  series2.tooltipText = "{name}: [bold]{valueY} orders[/]";
  series2.strokeWidth = 1;
  series2.tensionX = 0.8;
  series2.bullets.push(new am4charts.CircleBullet());
  series2.connect = true;
  linechart.legend = new am4charts.Legend();
  linechart.cursor = new am4charts.XYCursor();
}
export function showBarChartDestinationUserTypes(datas, container) {
  var chart = am4core.create(container, am4charts.XYChart);
  chart.data = datas;
  chart.colors.list = colors;

  // Create axes
  var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  categoryAxis.dataFields.category = "country";
  categoryAxis.renderer.grid.template.location = 0;
  categoryAxis.renderer.minGridDistance = 20;
  var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

  // Create series
  var series = chart.series.push(new am4charts.ColumnSeries());
  series.dataFields.valueY = "nb_ind";
  series.dataFields.categoryX = "country";
  series.name = "Individuals";
  series.tooltipText = "{name}: [bold]{valueY} orders[/]";
  series.stacked = true;
  var series2 = chart.series.push(new am4charts.ColumnSeries());
  series2.dataFields.valueY = "nb_pro";
  series2.dataFields.categoryX = "country";
  series2.name = "Professionals";
  series2.tooltipText = "{name}: [bold]{valueY}[/]";
  series2.stacked = true;

  // Add cursor
  chart.cursor = new am4charts.XYCursor();
}
export function showBarChartReferences(datas, container) {
  var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "bottles";
  var chart = am4core.create(container, am4charts.XYChart);
  chart.data = datas;
  chart.colors.list = colors;

  // Create axes
  var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  categoryAxis.dataFields.category = "text";
  // TODO use a real method to hide the labels
  categoryAxis.renderer.labels.template.adapter.add("text", function (text, target) {
    return "";
  });
  var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

  // Create series
  var series = chart.series.push(new am4charts.ColumnSeries());
  series.dataFields.valueY = "value";
  series.dataFields.categoryX = "text";
  series.name = "Quantity";
  series.tooltipText = "{categoryX}: [bold]{valueY} " + unit + "[/]";
  series.stacked = true;
  series.showTooltipAtPosition;

  // Add cursor
  chart.cursor = new am4charts.XYCursor();
}
export function showDestinationAnimatedMap(datas, container) {
  am4core.useTheme(am4themes_dark);
  // Create map instance
  var chart = am4core.create(container, am4maps.MapChart);
  chart.colors.list = colors;

  // Set map definition
  chart.geodata = am4geodata_worldLow;

  // Set projection
  chart.projection = new am4maps.projections.Miller();

  // Create map polygon series
  var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

  // Exclude Antartica
  polygonSeries.exclude = ["AQ"];

  // Make map load polygon (like country names) data from GeoJSON
  polygonSeries.useGeodata = true;

  // Configure series
  var polygonTemplate = polygonSeries.mapPolygons.template;
  polygonTemplate.tooltipText = "{name}";
  polygonTemplate.polygon.fillOpacity = 0.6;

  // Create hover state and set alternative fill color
  var hoverColor = am4core.color("#e4b379");
  var hs = polygonTemplate.states.create("hover");
  hs.properties.fill = hoverColor;

  // Add image series
  var imageSeries = chart.series.push(new am4maps.MapImageSeries());
  imageSeries.mapImages.template.propertyFields.longitude = "longitude";
  imageSeries.mapImages.template.propertyFields.latitude = "latitude";
  imageSeries.mapImages.template.tooltipText = "{title}";
  imageSeries.mapImages.template.propertyFields.url = "url";
  var circle = imageSeries.mapImages.template.createChild(am4core.Circle);
  circle.radius = 3;
  circle.propertyFields.fill = "color";
  var circle2 = imageSeries.mapImages.template.createChild(am4core.Circle);
  circle2.radius = 3;
  circle2.propertyFields.fill = "color";
  circle2.events.on("inited", function (event) {
    animateBullet(event.target);
  });
  var color = am4core.color("#936128");
  imageSeries.data = [];
  for (var i = 0; i < datas.length; i++) {
    imageSeries.data.push({
      title: datas[i].text + " (" + datas[i].value + " bottles)",
      latitude: datas[i].latitude,
      longitude: datas[i].longitude,
      color: color
    });
  }
  am4core.unuseTheme(am4themes_dark);
}
export function disposeCharts() {
  am4core.disposeAllCharts();
}
function animateBullet(circle) {
  var animation = circle.animate([{
    property: "scale",
    from: 1,
    to: 4
  }, {
    property: "opacity",
    from: 1,
    to: 0
  }], 1000, am4core.ease.circleOut);
  animation.events.on("animationended", function (event) {
    animateBullet(event.target.object);
  });
}